import { createGlobalStyle } from 'styled-components'

import { fontType, mediaQuery, toRem } from './functions'

import { animate } from './animated'

export const GlobalStyle = createGlobalStyle`

	

	* {
		margin: 0;
		padding: 0;
		outline: 0;
		box-sizing: border-box;
		font-family: 'Rubik', sans-serif;

	}

	html {
		font-size: 16px;

		${mediaQuery('xs')(`
			font-size: 16px;
		`)}
	}

	body {
		overflow-x: hidden;
	  }

	img {
		vertical-align: middle;
		border-style: none;
		max-width: 100%;
		object-fit: cover;
		object-position: center;
	}

	#ct-container {
		${fontType(1)};
	}

	.modal-primary {
		${fontType(0)};
		margin-top: ${toRem(80)};
		.modal-wrapper{
			background: #F9F9F9 !important;
		}
	}

	/* width */
	::-webkit-scrollbar {
		width: 8px;
		height: 6px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: rgb(238, 238, 238);
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 5px;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: lighten(#c1c1c1, 8);
	}
	.animated-left{
		opacity: 0;
		transform: translateX(-30%);
		animation: ${animate} 0.4s forwards;
	}

	.animated-right {
		opacity: 0;
		transform: translateX(20%);
		animation: ${animate} 0.4s forwards;
	}

	.animated-top {
		opacity: 0;
		transform: translateY(-10px);
		animation: ${animate} 0.4s forwards;
	}

	button,a{
		cursor: pointer;
	}

	.invisible-input {
		opacity: 0;      /* Make the input transparent */
		pointer-events: none; /* Disable interactions with the input */
	  }

	/* Override autofill background color */
	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active  {
		//-webkit-box-shadow: 0 0 0 30px #D9D9D9 inset !important;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
	}

	// .react-datepicker__year-dropdown {
	// 	height: 150px; /* Adjust the height as needed */
	// 	overflow-y: auto;
	//   }

	input[type="number"] {
	-moz-appearance: textfield;
	}

	.non-interactive-input {
		pointer-events: none; /* Prevent mouse interactions */
	  }

`
